import { render, staticRenderFns } from "./Res5.vue?vue&type=template&id=284753cf&scoped=true&lang=pug"
import script from "./Res5.vue?vue&type=script&lang=js"
export * from "./Res5.vue?vue&type=script&lang=js"
import style0 from "./Res5.vue?vue&type=style&index=0&id=284753cf&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284753cf",
  null
  
)

export default component.exports